import React from "react"

const Ascending = props => {
  return (
    <svg
      height='17'
      width='16'
      fill='none'
      viewBox='0 0 16 17'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M4.0402 11.6113L9.55387 6.0976L7.39355 6.05684L7.37145 4.8859L10.9494 4.93967L11.5355 4.96447L11.5599 5.55102L11.6141 9.12854L10.4432 9.10645L10.402 6.94653L4.88872 12.4598L4.0402 11.6113Z'
        fill='#131212'
      />
    </svg>
  )
}

export default Ascending
